var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-top":"30px","display":"flex","justify-content":"center"}},[_c('div',{ref:"vChinaMapChart",staticClass:"class-chinaMapChart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }